import { faFileSlash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { themeClass } from '~/styles/theme.css'
import type { AttachmentType } from '../../types'
import {
  attachmentPage,
  attachmentsGeneratingSubtitle,
  attachmentsGeneratingTitle,
  noAttachments,
  noAttachmentsIcon
} from '../AttachmentsViewer.css'

export const TextViewer = ({ attachment }: { attachment: AttachmentType }) => {
  if (!attachment.content) {
    return (
      <div className={clsx(noAttachments, themeClass)}>
        <div className={noAttachmentsIcon}>
          <FontAwesomeIcon icon={faFileSlash} />
        </div>
        <div className={attachmentsGeneratingTitle}>
          Erreur lors du chargement du fichier texte
        </div>
        <div className={attachmentsGeneratingSubtitle}>
          Le contenu du fichier n'est pas disponible.
        </div>
      </div>
    )
  }

  let textContent: string
  try {
    // Decode base64 content from utf-8
    textContent = decodeURIComponent(
      atob(attachment.content)
        .split('')
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    )
  } catch {
    // If base64 decode fails, assume content is already plain text
    textContent = attachment.content
  }

  return (
    <div className={attachmentPage}>
      <pre>{textContent}</pre>
    </div>
  )
}
